<template>
  <div class="formulario-terceiro">
    <transition-group
      name="terceiro-item"
      tag="div"
      class="formulario-terceiro__lista"
    >
      <div
        v-for="(form, index) in formularios"
        :key="form.id"
        class="formulario-terceiro__item"
      >
        <etapa-formulario>
          <div class="terceiro-passo" :class="{ 'is-ativo': passoAtivo(0) }">
            <div class="terceiro-passo-header">
              <div class="dados-form-heading" aria-hidden="true">
                <span class="dados-form-heading__marker">1</span>
                <span class="dados-form-heading__copy">
                  <strong>4 Campos nesta etapa</strong>
                </span>
                <span class="dados-form-heading__legend"
                  ><b>*</b> Obrigatório</span
                >
              </div>
              <b-button
                v-if="!modoVisualizacao && index > 0"
                type="button"
                variant="outline-danger"
                data-tooltip-location="left"
                @click="removerFormulario(index)"
                :aria-label="`Remover formulário ${index + 1}`"
                title="Remover este formulário"
                data-tooltip="Remover este formulário"
                class="formulario-terceiro__botao formulario-terceiro__botao--remover"
              >
                <i
                  class="mdi mdi-close-circle-outline formulario-terceiro__icone"
                  aria-hidden="true"
                ></i>

                <span class="formulario-terceiro__texto">
                  Remover
                </span>
              </b-button>
            </div>
            <secao-formulario
              :icone="false"
              campos-obrigatorios
              rotulo="Envolvido"
            >
              <b-button
                v-if="!modoVisualizacao && index > 0"
                type="button"
                variant="outline-danger"
                data-tooltip-location="left"
                @click="removerFormulario(index)"
                :aria-label="`Remover formulário ${index + 1}`"
                title="Remover este formulário"
                data-tooltip="Remover este formulário"
                class="formulario-terceiro__botao formulario-terceiro__botao--remover"
              >
                <i
                  class="mdi mdi-close-circle-outline formulario-terceiro__icone"
                  aria-hidden="true"
                ></i>

                <span class="formulario-terceiro__texto">
                  Remover
                </span>
              </b-button>
            </secao-formulario>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-3"
            >
              <campo-texto
                obrigatorio
                :maxlength="60"
                :value="form.nome"
                rotulo="Nome completo"
                :erro="erroDe(form, 'nome')"
                placeholder="Digite o nome completo"
                @input="atualizarCampo(form, 'nome', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-3 etapa-formulario__campo--xl-3"
            >
              <campo-texto
                obrigatorio
                rotulo="Telefone"
                :value="form.telefone"
                :erro="erroDe(form, 'telefone')"
                :disabled="!campoHabilitado(form, 'telefone')"
                placeholder="(00) 00000-0000"
                :maxlength="15"
                :limite-logico="11"
                tipo-contagem="digitos"
                unidade-limite="dígitos"
                aviso-limite-ao-exceder
                @input="atualizarCampo(form, 'telefone', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-3 etapa-formulario__campo--xl-3"
            >
              <campo-texto
                rotulo="CPF / CNPJ"
                :value="form.cpf"
                :erro="erroDe(form, 'cpf')"
                :disabled="!campoHabilitado(form, 'cpf')"
                placeholder="000.000.000-00 / 00.000.000/0000-00 / 12.ABC.345/01DE-35"
                :maxlength="18"
                :limite-logico="14"
                tipo-contagem="alfanumericos"
                unidade-limite="caracteres"
                aviso-limite-ao-exceder
                @input="atualizarCampo(form, 'cpf', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-3"
            >
              <campo-texto
                :value="form.veiculo"
                rotulo="Veículo (Placa)"
                :erro="erroDe(form, 'veiculo')"
                :disabled="!campoHabilitado(form, 'veiculo')"
                placeholder="AAA-0000 / AAA0A00"
                :maxlength="8"
                :limite-logico="7"
                tipo-contagem="alfanumericos"
                unidade-limite="caracteres"
                aviso-limite-ao-exceder
                @input="atualizarCampo(form, 'veiculo', $event)"
              />
            </div>
          </div>

          <div class="terceiro-passo" :class="{ 'is-ativo': passoAtivo(1) }">
            <div class="terceiro-passo-header">
              <div class="dados-form-heading" aria-hidden="true">
                <span class="dados-form-heading__marker">2</span>
                <span class="dados-form-heading__copy">
                  <strong>6 Campos nesta etapa</strong>
                </span>
                <span class="dados-form-heading__legend"
                  ><b>*</b> Obrigatório</span
                >
              </div>
            </div>
            <secao-formulario :icone="false" rotulo="Endereço" />

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-3 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                rotulo="CEP"
                :value="form.cep"
                :erro="erroDe(form, 'cep')"
                :disabled="!campoHabilitado(form, 'cep')"
                placeholder="00000-000"
                :maxlength="9"
                :limite-logico="8"
                tipo-contagem="digitos"
                unidade-limite="dígitos"
                aviso-limite-ao-exceder
                :carregando="carregandoEndereco"
                @input="atualizarCep(form, $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-5 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                disabled
                :value="form.municipio"
                rotulo="Município - UF"
                placeholder="Município - UF"
                :carregando="carregandoEndereco"
                @input="atualizarCampo(form, 'municipio', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                disabled
                rotulo="Bairro"
                :value="form.bairro"
                placeholder="Bairro"
                :carregando="carregandoEndereco"
                @input="atualizarCampo(form, 'bairro', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-6 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                :disabled="
                  carregandoEndereco || !campoHabilitado(form, 'endereco')
                "
                :carregando="carregandoEndereco"
                rotulo="Endereço"
                :value="form.endereco"
                :erro="erroDe(form, 'endereco')"
                :maxlength="200"
                exibir-contador
                :exibir-aviso-limite="false"
                placeholder="Endereço"
                @input="atualizarCampo(form, 'endereco', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-3 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                :disabled="
                  carregandoEndereco || !campoHabilitado(form, 'numero')
                "
                :carregando="carregandoEndereco"
                rotulo="Número"
                :value="form.numero"
                :erro="erroDe(form, 'numero')"
                :maxlength="5"
                exibir-contador
                :exibir-aviso-limite="false"
                placeholder="Ex.: 123"
                @input="atualizarCampo(form, 'numero', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-9 etapa-formulario__campo--xl-4"
            >
              <campo-texto
                :disabled="
                  carregandoEndereco || !campoHabilitado(form, 'complementos')
                "
                :carregando="carregandoEndereco"
                rotulo="Complemento"
                :value="form.complementos"
                :erro="erroDe(form, 'complementos')"
                :maxlength="50"
                exibir-contador
                :exibir-aviso-limite="false"
                placeholder="Complemento"
                @input="atualizarCampo(form, 'complementos', $event)"
              />
            </div>
          </div>

          <div class="terceiro-passo" :class="{ 'is-ativo': passoAtivo(2) }">
            <div class="terceiro-passo-header">
              <div class="dados-form-heading" aria-hidden="true">
                <span class="dados-form-heading__marker">3</span>
                <span class="dados-form-heading__copy">
                  <strong>3 Campos nesta etapa</strong>
                </span>
                <span class="dados-form-heading__legend"
                  ><b>*</b> Obrigatório</span
                >
              </div>
            </div>
            <secao-formulario
              :icone="false"
              rotulo="Informações da ocorrência"
            />

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
            >
              <campo-selecao
                :value="form.lesao"
                rotulo="Houve lesão?"
                :opcoes="opcoesTipoLesao"
                :desabilitado="!campoHabilitado(form, 'lesao')"
                :placeholder="'Selecione o tipo da lesão'"
                @input="atualizarCampo(form, 'lesao', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
            >
              <campo-selecao
                rotulo="Culpado(a)?"
                :value="form.culpado"
                :opcoes="opcoesCulpado"
                :desabilitado="!campoHabilitado(form, 'culpado')"
                :placeholder="'Selecione se foi culpado ou não'"
                @input="atualizarCampo(form, 'culpado', $event)"
              />
            </div>

            <div
              class="etapa-formulario__campo etapa-formulario__campo--md-4 etapa-formulario__campo--xl-4"
            >
              <campo-selecao
                :value="form.custos"
                :opcoes="opcoesArcaComCusto"
                rotulo="Irá arcar com os custos?"
                :desabilitado="!campoHabilitado(form, 'custos')"
                :placeholder="'Selecione se irá arcar com os custos ou não'"
                @input="atualizarCampo(form, 'custos', $event)"
              />
            </div>
            <p
              v-if="passoMobile === 2 && !modoVisualizacao"
              class="dados-review-note"
            >
              <i class="mdi mdi-shield-check-outline" aria-hidden="true"></i>
              <span>Você poderá conferir tudo antes de enviar.</span>
            </p>
          </div>
        </etapa-formulario>
      </div>
    </transition-group>
  </div>
</template>

<script lang="js">
import CampoTexto from "../campos/CampoTexto.vue";
import EtapaFormulario from "../EtapaFormulario.vue";
import SecaoFormulario from "../SecaoFormulario.vue";
import CampoSelecao from "../campos/CampoSelecao.vue";

/**
 * Formulário de inclusão/edição/visualização de terceiros envolvidos.
 *
 * Dumb component: estado em `EnvolvimentoTerceiros.formularios`; comunica via eventos.
 *
 * Em modo visualização (`inject modoVisualizacao=true` via
 * `VisualizarRelatoOcorrenciaContainer`):
 * - Campos `CampoTexto`/`CampoSelecao` ficam desabilitados via `inject`.
 * - Ações de edição ficam ocultas:
 *   - botão `Remover`
 *
 * Novos envolvidos são incluídos somente pela grid (`ListaTerceiros` →
 * evento `novo`), um por vez, evitando múltiplos formulários simultâneos.
 *
 * Mantém o estado no componente pai e utiliza eventos para comunicar alterações.
 *
 * @prop {Array<TerceiroForm>} formularios
 * @prop {Array<{value:string|number,label:string}>} opcoesTipoLesao
 * @prop {Array<{value:string,label:string}>} opcoesCulpado
 * @prop {Array<{value:string,label:string}>} opcoesArcaComCusto
 * @prop {Object<string, Object<string,string>>} validacao
 * @prop {boolean} [carregandoEndereco=false]
 *
 * @inject {boolean} modoVisualizacao
 *
 * @emits atualizar-campo {Object} form, {string} campo, {*} valor
 * @emits cep-input {Object} form, {string} valor
 * @emits remover-formulario {number} index
 */
export default {
  name: "FormularioTerceiro",

  components: {
    CampoSelecao,
    CampoTexto,
    EtapaFormulario,
    SecaoFormulario
  },

  inject: {
    modoVisualizacao: {
      type: Boolean,
      default: false
    }
  },

  props: {
    formularios: {
      type: Array,
      default: () => []
    },

    opcoesTipoLesao: {
      type: Array,
      default: () => []
    },

    opcoesCulpado: {
      type: Array,
      default: () => []
    },

    opcoesArcaComCusto: {
      type: Array,
      default: () => []
    },

    validacao: {
      type: Object,
      default: () => ({})
    },

    carregandoEndereco: {
      type: Boolean,
      default: false
    },

    passoMobile: {
      type: Number,
      default: 0
    }
  },

  methods: {
    passoAtivo(indice) {
      return this.passoMobile === indice;
    },
    temValorPreenchido(val) {
      if (val === null || val === undefined || val === "") return false;
      if (typeof val === "object") {
        const inner = val.value !== undefined ? val.value : val.label;
        return inner !== null && inner !== undefined && inner !== "";
      }
      return String(val).trim() !== "";
    },

    campoHabilitado(form, campo) {
      if (!form || this.modoVisualizacao) return false;
      if (!campo || campo === "nome") return true;
      if (campo === "telefone") return this.temValorPreenchido(form.nome);
      return (
        this.temValorPreenchido(form.nome) &&
        this.temValorPreenchido(form.telefone)
      );
    },
    atualizarCampo(form, campo, valor) {
      this.$emit("atualizar-campo", form, campo, valor);
    },
    atualizarCep(form, valor) {
      this.$emit("cep-input", form, valor);
    },
    removerFormulario(index) {
      this.$emit("remover-formulario", index);
    },
    erroDe(form, campo) {
      const erros = this.validacao[form.id];

      return erros && erros[campo] ? erros[campo] : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/_main";
@import "../../../styles/components/_etapas";
@import "../../../styles/components/_terceiros";
</style>


